export const ROUTE_NAMES = {
  LOGIN: 'Login',
  DASHBOARD: 'Dashboard',
  HOME: 'Home',
  CUSTOMER_OPERATION_APPROVAL: 'CustomerOperationApproval',
  CUSTOMER_ACCESS_HOME: 'CustomerAccessHome',
  CUSTOMER_ACCESS_OPERATIONS: 'CustomerAccessOperations',
  CUSTOMER_ACCESS_OPERATION_REPORT: 'CustomerAccessOperationReport',
  CUSTOMER_ACCESS_ACCOUNT: 'CustomerAccessAccount',
  CUSTOMER_ACCESS_OPERATION_DETAIL: 'CustomerAccessOperationDetail',
  CUSTOMER_ACCESS_WALLETS: 'CustomerAccessWallets',
  PAGE_NOT_FOUND: 'PageNotFound',
  PAGE_NOT_PERMISSION: 'PageNotPermission',
  CUSTOMER_SELFIE_EXTERNAL_ACCESS: 'CustomerSelfieExternalAccess',
  CUSTOMER_DOCUMENTS_EXTERNAL_ACCESS: 'CustomerDocumentsExternalAccess',
  OPERATION_DOCUMENTS_EXTERNAL_ACCESS: 'OperationDocumentsExternalAccess',
  DUIMP_EXTERNAL_ACCESS: 'DuimpExternalAccess',
  BANK_DOCUMENTS_EXTERNAL_ACCESS: 'BankDocumentsExternalAccess',
  FILE_VIEW: 'FileView',
  FORM_CUSTOMER_FINALLY: 'FormCustomerFinally',
  FORM_EDIT_CUSTOMER_EXTERNAL_ACCESS: 'FormEditCustomerExternalAcess',
  FORM_EDIT_CORRESPONDENT_EXTERNAL_ACCESS: 'FormEditCorrespondentExternalAcess',
  CORBAN_PUBLIC_SIGNUP: 'CorbanPublicSignup',
  ASSINATURA: 'Assinatura',
  CONFIRMACAO_ASSINATURA: 'ConfirmacaoAssinatura',
  CUSTOMER_DASHBOARD: 'CustomerDashboard',
  FIRST_STEPS: 'FirstSteps',
  SUPPORT: 'SupportRedirect',
  EXTERNAL_SHORT_LINK: 'ExternalShortLink'
};

export const SUPPORT_ENTRY_PATH = '/suporte';

